import { RootState } from "store/store";

export const selectIsSmall = (state: RootState) => state.configs.isSmall;
